import ProductScreens from "../../../../src/markdown/blueprints/resources/product-screens/ProductScreens";
import data from "../../../../src/markdown/blueprints/resources/product-screens/data";
import * as React from 'react';
export default {
  ProductScreens,
  data,
  React
};